import React, { createContext, useContext, useState, useEffect } from "react";
import { api } from "@/lib/api";
import { translations } from "@/lib/i18n";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lang, setLang] = useState(() => localStorage.getItem("solair_lang") || "it");

  useEffect(() => {
    const token = localStorage.getItem("solair_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("solair_token"); })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { localStorage.setItem("solair_lang", lang); }, [lang]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("solair_token", data.access_token);
    setUser(data.user);
    return data.user;
  };
  const register = async (email, password, name, referralCode) => {
    const body = { email, password, name };
    if (referralCode) body.referral_code = referralCode;
    const { data } = await api.post("/auth/register", body);
    localStorage.setItem("solair_token", data.access_token);
    setUser(data.user);
    return data.user;
  };
  const refreshUser = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch { return null; }
  };
  const logout = () => {
    localStorage.removeItem("solair_token");
    setUser(null);
  };

  const t = translations[lang];

  return (
    <AppContext.Provider value={{ user, loading, login, register, logout, refreshUser, lang, setLang, t }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
